import httpClient from '../utils/httpClient';
import GLOBAL from '../config/global';
import { useQuery } from '@tanstack/react-query';
// import axios from 'axios';

function usePurchaseOrderDetails(poNumber, accessToken = '') {
  const { data, error, isLoading } = useQuery({
    queryKey: ['purchaseOrderDetails', poNumber],

    queryFn: () => fetchPurchaseOrderDetails(poNumber, accessToken),

    // Only run the query if poNumber is truthy
    enabled: !!poNumber,

    staleTime: 60 * 1000,
  });

  return [data, error, isLoading];
}

async function fetchPurchaseOrderDetails(poNumber, accessToken) {
  const poNumbers = poNumber
    .replaceAll(' ', '')
    .split(',')
    .filter((poNum) => poNum.trim());

  // Lookup each PO on SAP and store the response
  // for further processing...
  const parallelRequests = [];
  for (const po_number of poNumbers) {
    const reqConfig = {};

    if (accessToken) {
      reqConfig.headers = {
        Authorization: `Bearer ${accessToken}`,
      };
    }

    const response = await httpClient.get(
      `${GLOBAL.API_URL}/getPurchaseOrderDetails/${po_number}`,
      reqConfig,
    );
    // const response = await axios.get(
    //   `https://996v4qqen4.execute-api.af-south-1.amazonaws.com/dev/getPOCosmic88TigerBubble/${poNumber}`,
    //   reqConfig,
    // );
    parallelRequests.push(response);
  }
  const responses = await Promise.all(parallelRequests);
  var poLines = [];
  var GoodsReceipts = {};
  var DocTotal = 0;
  var DocType = '';
  var RemainingBalance = 0;
  for (const res of responses) {
    if (!!!res?.data?.message?.status) {
      continue;
    }
    console.log(
      'Doc Total and conversion:::',
      res?.data?.message?.PurchaseOrders?.DocTotal,
      parseFloat(res?.data?.message?.PurchaseOrders?.DocTotal || '0'),
    );
    DocTotal += parseFloat(res?.data?.message?.PurchaseOrders?.DocTotal || '0');
    DocType = res?.data?.message?.PurchaseOrders?.DocType;
    const GRVs = res?.data?.message?.PurchaseOrders?.GoodsReceipts || [];
    GoodsReceipts = { ...GoodsReceipts, ...GRVs };
    RemainingBalance += parseFloat(
      res?.data?.message?.PurchaseOrders?.RemainingBalance || '0',
    );
    const poDocEntry =
      res?.data?.message?.PurchaseOrders?.DocEntry || 'Not Found';
    const poNumber =
      res?.data?.message?.PurchaseOrders?.PONumber || 'Not Found';
    var Lines = res?.data?.message?.PurchaseOrders?.Lines || [];
    for (let k = 0; k < Lines.length; k++) {
      Lines[k].PODocNum = poDocEntry;
      Lines[k].PONumber = poNumber;
    }
    poLines = [...poLines, ...Lines];
  }
  console.log('Good Receipts API call:', GoodsReceipts);
  var result = { data: { message: { PurchaseOrders: {} } } };
  console.log('Purchase Order Lines:::', poLines);
  result.data.message.PurchaseOrders.Lines = poLines;
  result.data.message.PurchaseOrders.GoodsReceipts = GoodsReceipts;
  result.data.message.PurchaseOrders.RemainingBalance = RemainingBalance;
  result.data.message.PurchaseOrders.DocTotal = DocTotal;
  result.data.message.PurchaseOrders.DocType = DocType;
  return result.data.message;
}

export default usePurchaseOrderDetails;
